export default {
  hasPendingAjax: state => state.loadingCount > 0,
  isSidebarHidden: state => state.isSidebarHidden,
  isContentsHidden: state => state.isContentsHidden,
}
